"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const ColonyName_1 = require("@/common/colonies/ColonyName");
const BuildBenefit_vue_1 = require("./BuildBenefit.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    components: { BuildBenefit: BuildBenefit_vue_1.default },
    name: 'ColonyRow',
    props: {
        idx: {
            type: Number,
            required: true,
        },
        metadata: {
            type: Object,
            required: true,
        },
        player: {
            type: String,
            default: undefined,
        },
        marker: {
            type: Boolean,
        },
    },
    computed: {
        ColonyName() {
            return ColonyName_1.ColonyName;
        },
    },
});
